<p-toolbar styleClass="alima-toolbar">
  <ng-template pTemplate="start">
    <div class="toolbar__start">
      @if (title && title.length > 0) {
        <div class="toolbar__title-group">
          <span class="toolbar__accent" aria-hidden="true"></span>
          <h2 class="toolbar__title">{{ title }}</h2>
        </div>
      }
      @if (search.observed) {
        <div class="toolbar__search">
          <span class="p-input-icon-left">
            <i class="pi pi-search"></i>
            <input pInputText placeholder="Rechercher..." (input)="onSearch($event)" />
          </span>
        </div>
      }
    </div>
  </ng-template>

  <ng-template pTemplate="end">
    <div class="toolbar__end">
      @if (actions.length > 0) {
        <div class="toolbar__actions">
          @for (action of actions; track action) {
            <p-button
              size="small"
              [label]="action.label"
              [severity]="action.severity"
              [icon]="action.icon"
              styleClass="primary-btn"
              (onClick)="action.emit($event)">
            </p-button>
          }
        </div>
      }
    </div>
  </ng-template>
</p-toolbar>
